import { DialogActions, DialogContent, DialogTitle, Icon, ListItem, ListItemIcon, ListItemText, MenuItem, Select, Tab, Tabs, TextField, Theme, Typography, WithStyles, FormControl, InputLabel, Input } from '@material-ui/core';
import { bindActions, mockTheme } from '../utils/utils';
import * as React from 'react';
import { ComponentClass } from 'react';
import Grid from '@material-ui/core/Grid';
import { DriverActions, IDriverStore } from '../store/driver';
import { SortDirection } from '@material-ui/core/TableCell';
import AsyncTable, { ColumnDefinition } from '../components/AsyncTable';
import { IStore } from '../store';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import DriverForm from '../components/DriverForm';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

import AddIcon from '@material-ui/icons/Add';
import HighlightOffIcon from '@material-ui/icons/PowerSettingsNew';
import EditIcon from '@material-ui/icons/ModeEdit';
import TrackIcon from '@material-ui/icons/TrackChanges';
import GetApp from '@material-ui/icons/GetApp';

import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import { ISubmitEvent } from 'react-jsonschema-form';
import Paper from '@material-ui/core/Paper';
import { Driver, DriverHistory, DriverVisitHistory, NotificationHistory, TypeNotification } from '../api/model';
import orange from '@material-ui/core/colors/orange';
import blue from '@material-ui/core/colors/blue';
import red from '@material-ui/core/colors/red';
import { Link } from 'react-router-dom';
import { getApi } from '../api/ApiProvider';
import { BranchData } from 'src/components/BranchSelector';
import DriverHistoryLocation from 'src/components/DriverHistoryLocation';
import { IConfigStore } from 'src/store/config';
import MapIcon from '@material-ui/icons/Map';
import PersonPinCicleIcon from '@material-ui/icons/PersonPinCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import DocumentIcon from '@material-ui/icons/Description';
import NotificationsIcon from '@material-ui/icons/Notifications';
import DriverHistoryVisit from 'src/components/DriverHistoryVisit';
import HighlightOff from '@material-ui/icons/Forward';

const styles = (theme: Theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: `calc(50% - ${theme.spacing.unit * 3}px)`,
    },
    menu: {
        width: 200,
    },

    routeSelector: {
        width: '100%',
        height: '100%'
    },
    buttons: {
        marginLeft: 'auto',
    },
    abm: {
        padding: theme.spacing.unit * 3,
        margin: theme.spacing.unit,
    },
    disableIcon: {
        color: orange[900]
    },
    editIcon: {
        color: blue[500]
    },
    trackIcon: {
        color: red[500]
    }
});


/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface DriversProps extends WithStyles<keyof typeof classesType> {

    actions: DriverActions;
    data: IDriverStore;
    config: IConfigStore;

}


interface DriversState {
    historyVisitData: DriverVisitHistory[],
    selectedType: TypeNotification
    notificationData: NotificationHistory[],
    tabValue: number;
    emptyDialogOpen: boolean;
    errorDialogOpen: boolean,
    selectedDriverId: number;
    historyData: DriverHistory[],
    isDialogVisitOpen: boolean;
    isDialogOpen: boolean;
    reportDialogOpen: boolean;
    startDate: string;
    endDate: string;
    fechaDesde: string;
    fechaHasta: string;
    branches: BranchData[];
    abm: {
        open: boolean,
        data?: Partial<Driver>
    },
    table: {
        data: any,
        sortBy: string,
        sortDirection: SortDirection
        columnData: ColumnDefinition[]
    },
    tableNotification: {
        data: any,
        sortBy: string,
        sortDirection: SortDirection
        columnData: ColumnDefinition[]
    },
    selectedReferenceIds: number[]
}
const getFormattedDateTime = (fecha: any) => {
    const now = fecha ? new Date(fecha) : new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1 < 10 ? '0' : '') + (now.getMonth() + 1);
    const day = (now.getDate() < 10 ? '0' : '') + now.getDate();
    const hours = (now.getHours() < 10 ? '0' : '') + now.getHours();
    const minutes = (now.getMinutes() < 10 ? '0' : '') + now.getMinutes();
    return `${year}-${month}-${day}T${hours}:${minutes}`;
};
// Schema and uiSchema removed - now using DriverForm component

class Drivers extends React.Component<DriversProps, DriversState> {

    mapRef: React.RefObject<any>;
    tableRef: React.RefObject<any>;

    constructor(props: DriversProps) {
        super(props);
        this.mapRef = React.createRef();
        this.tableRef = React.createRef();


        this.state = {
            historyVisitData: [],
            selectedType: TypeNotification.INDIVIDUAL,
            notificationData: [],
            tabValue: 0,
            emptyDialogOpen: false,
            errorDialogOpen: false,
            selectedDriverId: 0,
            historyData: [],
            isDialogVisitOpen: false,
            isDialogOpen: false,
            reportDialogOpen: false,
            startDate: this.toLocalISOString(new Date()).slice(0, 16),
            endDate: this.toLocalISOString(new Date()).slice(0, 16),
            fechaDesde: '',
            fechaHasta: '',
            branches: [],
            abm: {
                open: false,
                data: undefined
            },
            table: {
                data: [],
                sortBy: 'name',
                sortDirection: 'desc',
                columnData: [
                    {
                        path: '',
                        numeric: true,
                        label: 'Acciones',
                        draw: (cd: ColumnDefinition, data: Driver) => {
                            return (
                                <div>
                                    <Link to={{
                                        pathname: `/driverDetail`,
                                        state: {
                                            data: data,
                                            config: this.props.config.data
                                        }
                                    }}>
                                        <IconButton aria-label='Desabilitar' title='Ver'>
                                            <HighlightOff />
                                        </IconButton>
                                    </Link>
                                </div>
                            )
                        }
                    },
                    { path: 'id', numeric: false, label: 'Id', widht: "10%" },
                    { path: 'user.name', numeric: false, label: 'Nombre', widht: "10%" },
                    { path: 'user.email', numeric: false, label: 'Correo', widht: "10%" },
                    // { path: 'region', numeric: true, label: 'Region' },
                    {
                        path: '',
                        numeric: true,
                        label: 'Acciones',
                        draw: (cd: ColumnDefinition, data: Driver) => {
                            return (
                                <div style={{ display: "flex", justifyContent: "end" }}>
                                    <Button onClick={() => this.handleIconClickVisit(data.id)} style={{ padding: 5 }}>
                                        <ListItem button title="Visitados" style={{ padding: 0 }}>
                                            <ListItemIcon style={{ margin: 0 }} className={this.props.classes.editIcon}>
                                                <PersonPinCicleIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Visitados" style={{ padding: "0 5px" }} />
                                        </ListItem>
                                    </Button>
                                    <Dialog
                                        open={this.state.isDialogVisitOpen}
                                        onClose={() => this.setState({ isDialogVisitOpen: false })}
                                        PaperProps={{
                                            style: {
                                                backgroundColor: '#fff', // Set the background color to transparent
                                                // boxShadow: 'none', // Remove the shadow
                                                boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.2)',
                                            },
                                        }}
                                        BackdropProps={{
                                            style: {
                                                backgroundColor: 'transparent', // Set the backdrop color to transparent
                                            },
                                        }}

                                    >
                                        <DialogTitle>Seleccione las fechas de visita</DialogTitle>
                                        <DialogContent>
                                            <p>Desde</p>
                                            <TextField
                                                required
                                                type="datetime-local"
                                                value={this.state.startDate}
                                                onChange={e => this.setState({ startDate: e.target.value })}
                                            />
                                            <hr />
                                            <p>Hasta</p>
                                            <TextField
                                                required
                                                type="datetime-local"
                                                value={this.state.endDate}
                                                onChange={e => this.setState({ endDate: e.target.value })}
                                            />
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={() => this.setState({ isDialogVisitOpen: false })} color="primary">
                                                Cancelar
                                            </Button>
                                            <Button onClick={() => {
                                                this.historyVisit(data.id, this.state.startDate, this.state.endDate);
                                                this.setState({ isDialogVisitOpen: false });
                                            }} color="primary">
                                                Aceptar
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                    <Button onClick={() => this.handleClickNotification(data.id)} style={{ padding: 5 }}>
                                        <ListItem button title="Notificaciones" style={{ padding: 0 }}>
                                            <ListItemIcon style={{ margin: 0 }} className={this.props.classes.disableIcon}>
                                                <NotificationsIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Notificaciones" />
                                        </ListItem>
                                    </Button>
                                    <Button onClick={() => this.handleIconClick(data.id)} style={{ padding: 5 }}>
                                        <ListItem button title="Recorridos" style={{ padding: 0 }}>
                                            <ListItemIcon style={{ margin: 0 }} className={this.props.classes.editIcon}>
                                                <MapIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Recorridos" style={{ padding: "0 5px" }} />
                                        </ListItem>
                                    </Button>
                                    <Dialog
                                        open={this.state.isDialogOpen}
                                        onClose={() => this.setState({ isDialogOpen: false })}
                                        PaperProps={{
                                            style: {
                                                backgroundColor: '#fff', // Set the background color to transparent
                                                // boxShadow: 'none', // Remove the shadow
                                                boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.2)',
                                            },
                                        }}
                                        BackdropProps={{
                                            style: {
                                                backgroundColor: 'transparent', // Set the backdrop color to transparent
                                            },
                                        }}

                                    >
                                        <DialogTitle>Seleccione las fechas</DialogTitle>
                                        <DialogContent>
                                            <p>Desde</p>
                                            <TextField
                                                required
                                                type="datetime-local"
                                                value={this.state.startDate}
                                                onChange={e => this.setState({ startDate: e.target.value })}
                                            />
                                            <hr />
                                            <p>Hasta</p>
                                            <TextField
                                                required
                                                type="datetime-local"
                                                value={this.state.endDate}
                                                onChange={e => this.setState({ endDate: e.target.value })}
                                            />
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={() => this.setState({ isDialogOpen: false })} color="primary">
                                                Cancelar
                                            </Button>
                                            <Button onClick={() => {
                                                this.history(data.id, this.state.startDate, this.state.endDate);
                                                this.setState({ isDialogOpen: false });
                                            }} color="primary">
                                                Aceptar
                                            </Button>
                                        </DialogActions>
                                    </Dialog>

                                    <Link to={"/driver/" + data.id} style={{ display: "flex", alignItems: "center" }}>
                                        <Button>
                                            <ListItem button title="Seguir" style={{ padding: 0 }}>
                                                <ListItemIcon style={{ margin: 0 }} className={this.props.classes.trackIcon}>
                                                    <TrackIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="Seguir" style={{ padding: "0 5px" }} />
                                            </ListItem>
                                        </Button>
                                    </Link>
                                    <IconButton onClick={this.edit(data)} className={this.props.classes.editIcon} aria-label='Editar' title='Editar'>
                                        <EditIcon />
                                    </IconButton>
                                    {data.user.state === 'ACTIVE' && (
                                        <IconButton onClick={this.handleDisable(data)} title='Desabilitar' aria-label='Desabilitar' className={this.props.classes.disableIcon}>
                                            <HighlightOffIcon />
                                        </IconButton>)}
                                </div>
                            )
                        }
                    }
                ]
            },
            tableNotification: {
                data: [],
                sortBy: 'name',
                sortDirection: 'desc',
                columnData: [
                    { path: 'message', numeric: false, label: 'Mensaje' },
                    { path: 'type', numeric: false, label: 'Tipo' },
                    { path: 'notificacionDate', numeric: false, label: 'Fecha' },
                ]
            },
            selectedReferenceIds: []
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.showDialog = this.showDialog.bind(this);
        this.hideDialog = this.hideDialog.bind(this);
        this.handleDisable = this.handleDisable.bind(this);
        this.handleReferenceSelectionChange = this.handleReferenceSelectionChange.bind(this);
        this.handleSubmitReport = this.handleSubmitReport.bind(this);
    }

    handleClickNotification(id: number) {
        this.setState({ selectedDriverId: id });
        console.log('id', id)
        getApi().history().notificationHistory(id).then(
            (data: NotificationHistory[]) => {
                this.setState({ notificationData: data });
                this.setState({ tabValue: 2 });
                if (this.mapRef.current) {
                    this.mapRef.current.focus();
                }
            }).catch(err => {
                this.setState({ errorDialogOpen: true });
                console.log('err', err)
            }
            )

    }
    handleIconClickVisit(id: number) {
        this.setState({
            isDialogVisitOpen: true,
            selectedDriverId: id, // Update selectedDriverId with the passed id
        });
        console.log('id', id)
    }
    handleIconClick(id: number) {
        this.setState({
            isDialogOpen: true,
            selectedDriverId: id, // Update selectedDriverId with the passed id
        });
        console.log('id', id)
    }

    handleDisable(data: any) {
        return (event: React.MouseEvent<HTMLElement>) => {
            this.props.actions.disable(data);
        }
    };

    // setRequired method removed - no longer needed with DriverForm

    toLocalISOString = (date: Date) => {
        const tzo = -date.getTimezoneOffset();
        const dif = tzo >= 0 ? '+' : '-';
        const pad = (num: number) => {
            const norm = Math.floor(Math.abs(num));
            return (norm < 10 ? '0' : '') + norm;
        };

        return date.getFullYear() +
            '-' + pad(date.getMonth() + 1) +
            '-' + pad(date.getDate()) +
            'T' + pad(date.getHours()) +
            ':' + pad(date.getMinutes()) +
            ':' + pad(date.getSeconds()) +
            dif + pad(tzo / 60) +
            ':' + pad(tzo % 60);
    }
    history = (id: number, startDate: string, endDate: string) => {
        const dateStart = new Date(startDate);
        const formattedDateStart = this.toLocalISOString(dateStart).slice(0, 16);

        const dateEnd = new Date(endDate);
        const formattedEndDate = this.toLocalISOString(dateEnd).slice(0, 16);

        const locationApi = getApi().history();
        locationApi.history(this.state.selectedDriverId, formattedDateStart, formattedEndDate).then((data) => {
            if (data.length === 0) {
                this.setState({ emptyDialogOpen: true });
            }
            this.setState({ historyData: data });
            this.setState({ tabValue: 0 });
            if (this.mapRef.current) {
                this.mapRef.current.focus();
            }
        }).catch(err => {
            this.setState({ errorDialogOpen: true });
            console.log('err', err)
        });
        // Do something with locationApi, startDate, endDate, and driverId
    };
    historyVisit = (id: number, startDate: string, endDate: string) => {
        const dateStart = new Date(startDate);
        const formattedDateStart = this.toLocalISOString(dateStart).slice(0, 16);

        const dateEnd = new Date(endDate);
        const formattedEndDate = this.toLocalISOString(dateEnd).slice(0, 16);

        const locationApi = getApi().history();
        locationApi.historyVisit(this.state.selectedDriverId, formattedDateStart, formattedEndDate).then((data) => {
            if (data.length === 0) {
                this.setState({ emptyDialogOpen: true });
            }
            this.setState({ historyVisitData: data });
            this.setState({ tabValue: 1 });
            if (this.mapRef.current) {
                this.mapRef.current.focus();
            }
        }).catch(err => {
            this.setState({ errorDialogOpen: true });
            console.log('err', err)
        });
        // Do something with locationApi, startDate, endDate, and driverId
    };

    handleEmptyDialogClose = () => {
        this.setState({ emptyDialogOpen: false });
    };
    handleErrorDialogClose = () => {
        this.setState({ errorDialogOpen: false });
    };


    edit(data: Driver) {
        return (event: React.MouseEvent<HTMLElement>) => {
            console.log('Editing driver:', data);
            this.setState({
                abm: {
                    open: true,
                    data: data
                }
            }, () => {
                console.log('this.state.abm.data', this.state.abm.data);
            });
        }
    };

    handleSubmit(e: ISubmitEvent<any>) {
        console.log('Driver form data:', e.formData);

        // if (e.formData.id) {
        //     return;
        // }

        // Asegurarse de enviar referenceId como parte del objeto driver
        const formData = {
            ...e.formData,
            driver: {
                ...e.formData.driver,
                referenceId: Number(e.formData.driver.referenceId) || 0
            }
        };

        this.props.actions.save(formData);
        this.hideDialog();
    }

    sort(name: string) {
        return () => {
            this.setState({
                ...this.state,
                table: {
                    ...this.state.table,
                    sortBy: name,
                    sortDirection: 'desc'
                }
            })

        }

    }

    cleanMap() {
        this.setState({
            historyData: []
        });
    }
    componentDidMount() {
        this.props.actions.fetch();
        // Cargar branches
        getApi().branch().listAllBranchesAdmin().then((data: BranchData[]) => {
            this.setState({ branches: data });
        });
    }

    hideDialog() {
        this.setState({
            abm: { ...this.state.abm, open: false }
        });
    }

    showDialog() {
        this.setState({
            abm: { data: undefined, open: true }
        });
    }

    handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        this.setState({ tabValue: newValue });
    };
    handleTypeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        this.setState({ selectedType: event.target.value as TypeNotification });
    };

    handleReportDialogClose = () => {
        this.setState({ reportDialogOpen: false });
    };
    showReportDialog = () => {
        this.setState({
            reportDialogOpen: true
        });
    }
    handleDateFromChange = (e: any) => {
        this.setState({ fechaDesde: e.target.value });
    };
    handleDateToChange = (e: any) => {
        this.setState({ fechaHasta: e.target.value });
    };

    handleReferenceSelectionChange(event: React.ChangeEvent<{ value: unknown }>) {
        this.setState({
            selectedReferenceIds: event.target.value as number[]
        });
    }

    handleSubmitReport() {
         if (this.state.selectedReferenceIds.length === 0) {
            alert('Por favor selecciona al menos un elemento');
            return;
        }
        const inicio = getFormattedDateTime(this.state.fechaDesde);
        const fin = getFormattedDateTime(this.state.fechaHasta);
        const data = {
            init: inicio,
            end: fin,
            driver: this.state.selectedReferenceIds,
            report: 5
        };
        console.log(data);
        getApi().report().reportAssists(data)
            .then(blob => {
                const file = new Blob([blob], {
                    type: "application/pdf"
                });
                const url = URL.createObjectURL(file);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'reporte_asistencias.pdf';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            });

    }

    exportCSV = () => {
        const drivers = this.props.data.data.data;
        const centralBranchName = "CENTRAL ACCESO SUR ÑEMBY";
        const rows: any[] = [];
        drivers.forEach((driver: any) => {
            if (driver.branch && driver.branch.name === centralBranchName && driver.vehicles) {
                driver.vehicles.forEach((vehicle: any) => {
                    rows.push({
                        matricula: vehicle.licensePlate || '',
                        capacidad: vehicle.capacity || '',
                        chofer: driver.user.name,
                        marca: vehicle.brand,
                        modelo: vehicle.model,
                        chasis: vehicle.chassis || '',
                        medida_furgon: vehicle.vanSize || '',
                        m3: vehicle.volume || vehicle.capacidadVolumetrica || '',
                        suc: driver.branch.name,
                        id: driver.id
                    });
                });
            }
        });
        const csvRows = rows.map(r => `"${r.matricula}","${r.capacidad}","${r.chofer}","${r.marca}","${r.modelo}","${r.chasis}","${r.medida_furgon}","${r.m3}","${r.suc}","${r.id}"`);
        const header = '"matricula","capacidad","chofer","marca","modelo","chasis","medida_furgon","m3","suc","id"';
        const fullCsv = [header, ...csvRows].join('\n');
        const blob = new Blob([fullCsv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'conductores.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    render() {
        return (
            <Grid container spacing={24}>
                <Grid item sm={12} md={12}>
                    <AsyncTable
                        showFiltro={true}
                        columnDefinition={this.state.table.columnData}
                        title='Usuarios'
                        data={this.props.data.data}
                        defaultOrder={{
                            name: 'name',
                            direction: 'desc'
                        }}
                        headerButtons={(
                            <div style={{ display: 'flex' }}>
                                <Tooltip title='Agregar cliente'>
                                    <IconButton aria-label='Agregar cliente' onClick={this.showDialog}>
                                        <AddIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title='Reporte de asistencias'>
                                    <IconButton aria-label='Reporte de asistencias' onClick={this.showReportDialog}>
                                        <DocumentIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title='Exportar CSV'>
                                    <IconButton aria-label='Exportar' onClick={this.exportCSV}>
                                        <GetApp />
                                    </IconButton>
                                </Tooltip>

                            </div>
                        )} />

                </Grid>
                <Dialog open={this.state.abm.open}
                    maxWidth='md'
                    fullWidth={true}
                >
                    <Paper className={this.props.classes.abm}>
                        <DriverForm
                            data={this.state.abm.data}
                            branches={this.state.branches}
                            sendData={this.handleSubmit}
                            cancel={this.hideDialog}
                        />
                    </Paper>
                </Dialog>

                <Grid item sm={12} md={12} >
                    <Paper elevation={5} style={{ padding: '10px', margin: '7px' }}>
                        <Tabs value={this.state.tabValue} onChange={this.handleTabChange}>
                            <Tab label="Historial de ubicaciones" />
                            <Tab label="Historial de visitas" />
                            <Tab label="Historial de notificaciones" />
                        </Tabs>
                        {this.state.tabValue === 0 && (
                            <Grid item sm={12} md={12} lg={12}>

                                <h3>Historial de ubicaciones <Icon color="primary"
                                    onClick={() => this.cleanMap()}
                                    title='Limpiar mapa'
                                >
                                    <DeleteIcon />
                                </Icon></h3>
                                <DriverHistoryLocation
                                    data={this.state.historyData} config={this.props.config.data} />
                                <hr ref={this.mapRef} tabIndex={-1} />

                            </Grid>
                        )}
                        {this.state.tabValue === 1 && (
                            <Grid>
                                <DriverHistoryVisit
                                    data={this.state.historyVisitData} config={this.props.config.data} />
                                <hr ref={this.mapRef} tabIndex={-1} />
                            </Grid>
                        )}
                        {this.state.tabValue === 2 && (
                            <Grid>
                                <Select
                                    value={this.state.selectedType}
                                    onChange={this.handleTypeChange}
                                >
                                    <MenuItem value={TypeNotification.INDIVIDUAL}>{TypeNotification.INDIVIDUAL}</MenuItem>
                                    <MenuItem value={TypeNotification.GROUP}>{TypeNotification.GROUP}</MenuItem>
                                    <MenuItem value={TypeNotification.AUTOMATIC}>{TypeNotification.AUTOMATIC}</MenuItem>
                                    <MenuItem value={TypeNotification.OTHER}>{TypeNotification.OTHER}</MenuItem>
                                </Select>
                                <AsyncTable
                                    columnDefinition={this.state.tableNotification.columnData}
                                    title='Notificaciones'
                                    data={this.state.notificationData}
                                    defaultOrder={{
                                        name: 'time',
                                        direction: 'desc'
                                    }}
                                />
                                <hr ref={this.tableRef} tabIndex={-1} />
                            </Grid>
                        )}
                    </Paper>
                </Grid>
                <Dialog
                    open={this.state.emptyDialogOpen}
                >
                    <DialogTitle>Sin datos para mostrar.</DialogTitle>
                    <div style={{ textAlign: 'center' }}>
                        <Button variant='contained' onClick={this.handleEmptyDialogClose}>
                            Aceptar
                        </Button>
                    </div>
                </Dialog>
                <Dialog
                    open={this.state.errorDialogOpen}
                >
                    <DialogTitle>Hubo un error en la petición</DialogTitle>
                    <div style={{ textAlign: 'center' }}>
                        <Button variant='contained' onClick={this.handleErrorDialogClose}>
                            Aceptar
                        </Button>
                    </div>
                </Dialog>
                <Dialog
                    open={this.state.reportDialogOpen}
                >
                    <DialogTitle>Generar reporte de asistencias</DialogTitle>
                    <DialogContent>
                        <Typography gutterBottom>
                            Seleccionar opciones
                        </Typography>
                        <div style={{ width: '100%' }}>
                            <TextField
                                label="Fecha Desde"
                                type="datetime-local"
                                value={this.state.fechaDesde}
                                onChange={this.handleDateFromChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                style={{ marginLeft: 10 }}
                            />
                        </div>
                        <div style={{ width: '100%' }}>
                            <TextField
                                label="Fecha Hasta"
                                type="datetime-local"
                                value={this.state.fechaHasta}
                                onChange={this.handleDateToChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                style={{ marginLeft: 10 }}
                            />
                        </div>

                        <div style={{ width: '100%', marginTop: '20px' }}>
                            <Typography gutterBottom>
                                Seleccionar usuarios
                            </Typography>
                            <FormControl fullWidth style={{ marginLeft: 10 }}>
                                <InputLabel>Seleccionar referenceIds</InputLabel>
                                <Select
                                    multiple
                                    value={this.state.selectedReferenceIds}
                                    onChange={this.handleReferenceSelectionChange}
                                    input={<Input />}
                                    renderValue={(selected) => (selected as number[]).join(', ')}
                                >
                                    {this.props.data.data && this.props.data.data.data && Array.isArray(this.props.data.data.data) && this.props.data.data.data.map((item: any) => (
                                        <MenuItem key={item.referenceId} value={item.referenceId}>
                                            {item.referenceId} - {item.user.name || 'Sin nombre'}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleReportDialogClose} color="primary">
                            Cancelar
                        </Button>
                        <Button
                            onClick={this.handleSubmitReport}
                            variant="contained"
                            color="primary"
                            disabled={this.state.selectedReferenceIds.length === 0}
                        >
                            Enviar Seleccionados ({this.state.selectedReferenceIds.length})
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: DriversProps) => ({
    ...ownProps,
    data: state.driver,
    config: state.config,
});


const styled = withStyles(styles as any)(Drivers);
const connected = connect(mapStateToProps, bindActions(DriverActions))(styled);

export default connected as ComponentClass<Partial<DriversProps>>;



// WEBPACK FOOTER //
// ./src/pages/DriverListPage.tsx